import { useContext } from 'react';
import { CompanyClubContext } from '@contexts/companyClub/companyClub-context';
import { countryIsoToIso2 } from '@utils/country-iso-to-iso2/index';

/**
 * Returns the current club's country code normalised to ISO 3166-1 alpha-2
 * (e.g. `PT`, `ES`, `IT`), which is the format expected by the backend.
 *
 * Reads the country from `CompanyClubContext`, which exposes the code as
 * alpha-3. Returns `undefined` when the context is empty (no venue selected yet).
 */
export const useClubCountryIso2 = (): string | undefined => {
  const { clubState } = useContext(CompanyClubContext);
  return countryIsoToIso2(clubState.city.country.isoCode);
};
